// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__2uyKJ","modal":"Modal_modal__jU3J-"};